import { useIsMutating, useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { useAlertContext } from '@/contexts/AlertContext'
import { importIntradayEnergyOffer } from '@/features/bidding/endpoints/bids'

const IMPORT_INTRADAY_ENERGY_OFFER_API_ID = 'IMPORT_INTRADAY_ENERGY_OFFER'

export function useImportIntradayEnergyOfferMutation() {
  const { t } = useTranslation()
  const { pushAlert } = useAlertContext()

  const { mutateAsync, ...mutationResult } = useMutation({
    mutationFn: (tsvRows: string) => importIntradayEnergyOffer(tsvRows),
    mutationKey: [IMPORT_INTRADAY_ENERGY_OFFER_API_ID],
    onError: () => {
      pushAlert({
        message: t('bidding.import_energy_offer.sending_failed.text'),
        severity: 'error',
        title: t('bidding.import_energy_offer.sending_failed.title'),
      })
    },
  })

  return {
    importIntradayEnergyOffer: mutateAsync,
    ...mutationResult,
  }
}

export const useIsImportingIntradayEnergyOffer = (): boolean =>
  useIsMutating({ mutationKey: [IMPORT_INTRADAY_ENERGY_OFFER_API_ID] }) > 0
